import { Row, Col } from 'antd'
import dayjs from 'dayjs'

import _map from 'lodash/map'

import Title from 'components/Title'
import Button from 'components/Button'
import Link from 'components/Link'
import CardPromotion from 'components/Card/CardPromotion'

import Styled from './styled'

export default function SectionPromotion({ promotions }) {
  return (
    <Styled>
      <Title level={2} className="title">
        โปรโมชั่นสุดพิเศษ
      </Title>
      <div className="promotion-content">
        <Row
          justify="center"
          gutter={[
            { xs: 0, sm: 0, md: 0, lg: 30 },
            { xs: 20, sm: 20, md: 20, lg: 15 },
          ]}
        >
          {_map(promotions, (item, index) => {
            const image = item?.thumbnailImage?.[0]?.url
            const name = item?.title
            const slug = item?.code
            const detail = item?.shortDescription
            const expireDate = item?.validEndDate
            const link = `/voucher/${slug}`

            return (
              <Col span={24} lg={8} key={index}>
                <div className="promotion-block">
                  <Link href={link}>
                    <CardPromotion
                      image={image}
                      name={name}
                      detail={detail}
                      expireDate={expireDate ? dayjs(expireDate).format('DD/MM/YYYY') : null}
                    />
                  </Link>
                </div>
              </Col>
            )
          })}
        </Row>
      </div>

      <div className="button-block">
        <Link href="/voucher">
          <Button size="large">ดูโปรโมชั่นอื่นๆ</Button>
        </Link>
      </div>
    </Styled>
  )
}
